<section class="w3l-form-25">
    <div class="form-inner-cont">
        <div class="w3l-form-25">
            <h1>Users Master Data</h1>
            <p>Enter Users Master Data below to stay updated </p>
        </div>
    </div>

</section>



<div id="w3l-appointment">
    <section class="appointment-section section-gap">
        <div class="wrapper">
            <div class="d-grid doctor-appointment">
                <div class="appointment-form">
                    <form action="#" method="post">
                        <div class="fields-grid">
                            <div class="styled-input">
                                <label>User ID</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-search" aria-hidden="true" (click)="openDialog()"
                                        style="cursor: grab;"></span>
                                    <input type="text" name="UserID" placeholder="User ID" maxlength="15ch" required=""
                                        [(ngModel)]="userID" (change)="retriveUsers()" style="width: 30%;">

                                </div>
                            </div>
                            <div class="styled-input">
                                <label>User Name</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-user-circle" aria-hidden="true"></span>
                                    <input type="text" name="username" placeholder="User Name" required=""
                                        maxlength="50ch" [(ngModel)]="userName">
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Password</label>
                                <div class="appointment-form-field form-input">
                                    <span class="fa fa-key" aria-hidden="true"></span>
                                    <input type="password" name="password"  placeholder="Password" [(ngModel)]="password" required >
                                </div>
                                <!-- <div class="form-input">
                                  <span class="fa fa-key" aria-hidden="true"></span>
                                    <input type="password" name="password"  placeholder="Password" [(ngModel)]="password"  required />
                                </div> -->
                            </div>

                            <div class="styled-input">
                                <label>User Group</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-sitemap" aria-hidden="true"></span>
                                    <select id="Group" name="Group" required="" [(ngModel)]="groupCode">
                                        <option value="{{grp.groupsCode}}"
                                            *ngFor="let grp of groupsList; let i = index">
                                            {{grp.groupsName}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="styled-input" >
                              <label>Doctor Code</label>
                              <div class="appointment-form-field">
                                  <span class="fa fa-sitemap" aria-hidden="true"></span>
                                  <select id="doc" name="doc" required="" [(ngModel)]="empID"    [value]="userID">
                                      <option value="" > </option>
                                      <option value="{{grp.docCode}}" *ngFor="let grp of doctorList; let i = index">{{grp.docName}}</option>
                                  </select>
                              </div>
                          </div>


                            <div class="styled-input">
                                <label>User Status              : </label>
                                <input type="radio" name="DStatus" value="1" checked [(ngModel)]="enabled"> Active    
                                <input type="radio" name="DStatus" value="2" [(ngModel)]="enabled"> Non-Active
                            </div>
                            <!-- <div class="styled-input">
                                <label>Photo</label>
                                <div class="appointment-form-field">
                                    <input (change)="picked($event)" type="file" id="photo" name="photo"
                                        accept="image/*">
                                </div>
                                <BR>
                                <BR>



                            </div>
                            <BR>
                            <BR>
                            <BR>


                            <div class="styled-input">
                                <div class="appointment-form-field">
                                  <img src="assets/images/Person.jpg" *ngIf= "!wk_Pic_Not" alt="Item Image" width="200px" height="200px" style="border: 1px;border-style: double;"/>
                                  <img src="data:image/jpg;base64,{{myimage}}" *ngIf= "!wk_Pic_Not1" class="img-circle" alt="User Image" width="200px" height="200px"/>

                                </div>
                            </div> -->

                            <BR>
                            <BR>
                            <BR>
                            <BR>
                            <BR>
                            <BR>
                            <button type="button" class="theme-button btn" name="submit"
                                (click)="submitUsers()">Submit</button>
                            <button type="button" class="theme-button btn" name="Delete"
                                (click)="mesgDelete()">Delete</button>
                            <button type="button" class="theme-button btn" name="New" (click)="NewData()">New</button>
                            <a href="Home">
                                <button type="button" class="theme-button btn" style="width: 83%;"
                                    name="Back">Home</button>
                            </a>
                            <div class="clear"> </div>

                        </div>

                    </form>
                </div>

                <div class="styled-input">

                  <label>Photo</label>
                  <div class="appointment-form-field">
                      <input (change)="picked($event)" type="file" id="photo" name="photo" style="width: 86%;"
                          accept="image/*">
                  </div>
                  <BR>
                  <BR>
                    <BR>
                      <BR>
                        <BR>
                          <BR>
                            <BR>
                              <BR>
                                <BR>
                                  <BR>
                                    <BR>
                                      <BR>
                    <div class="styled-input">
                      <div class="appointment-form-field" style="text-align: center;align-items: center;">
                        <img src="assets/images/Person.jpg" *ngIf= "!wk_Pic_Not" alt="Item Image" width="500px" height="500px" style="border: 1px;border-style: double;"/>
                        <img src="data:image/jpg;base64,{{myimage}}" *ngIf= "!wk_Pic_Not1" class="img-circle" alt="User Image" width="500px" height="500px"/>

                      </div>
                  </div>

              </div>



                <!-- <div class="registerimg">
                    <img src="assets/images/groupofmembersusers.png" alt="" />
                </div> -->

            </div>
            <div class="clear"> </div>
        </div>
    </section>
</div>
